
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DoubleImageInfoModal',
  props: {
    before_image_list: {
      type: Array,
      required: true,
    },
    after_image_list: {
      type: Array,
      required: true,
    },
  },
  emits: ['ok', 'cancel'],
  setup(props: any, { emit }: any) {
    const handleSubmit = (e: Event) => {
      e.preventDefault();

      emit('ok');
    };

    return {
      props,
      handleSubmit,
    };
  },
});
